import * as types from './actionTypes';

// Regular action creators
// ------- Fetch New Quotation
export function fetchNewQuotation({ value, date, dateFormat, commercialproduct }) {
  return {
    type: types.FETCH_NEW_QUOTATION_REQUEST,
    id: value,
    date,
    dateFormat,
    commercialproduct,
  };
}

export function fetchNewQuotationSuccess({ data }) {
  return {
    type: types.FETCH_NEW_QUOTATION_SUCCESS,
    data,
  };
}

export function fetchNewQuotationFail({ error }) {
  return {
    type: types.FETCH_NEW_QUOTATION_FAIL,
    error,
  };
}

// ------- Fetch New Quotation as Salesroute
export function fetchNewQuotationSR({ value, date, dateFormat, commercialproduct }) {
  return {
    type: types.FETCH_NEW_QUOTATION_SR_REQUEST,
    id: value,
    date,
    dateFormat,
    commercialproduct,
  };
}

export function fetchNewQuotationSRSuccess({ data }) {
  return {
    type: types.FETCH_NEW_QUOTATION_SR_SUCCESS,
    data,
  };
}

export function fetchNewQuotationSRFail({ error }) {
  return {
    type: types.FETCH_NEW_QUOTATION_SR_FAIL,
    error,
  };
}

// ------- Fetch Quotation
export function fetchQuotation({ id }) {
  return {
    type: types.FETCH_QUOTATION_REQUEST,
    id,
  };
}

export function fetchQuotationSuccess(data, id) {
  return {
    type: types.FETCH_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function fetchQuotationFail(error) {
  return {
    type: types.FETCH_QUOTATION_FAIL,
    error,
  };
}
// ------- Fetch Quotation as Salesroute
export function fetchQuotationSR({ id }) {
  return {
    type: types.FETCH_QUOTATION_SR_REQUEST,
    id,
  };
}

export function fetchQuotationSRSuccess(data, id) {
  return {
    type: types.FETCH_QUOTATION_SR_SUCCESS,
    data,
    id,
  };
}

export function fetchQuotationSRFail(error) {
  return {
    type: types.FETCH_QUOTATION_SR_FAIL,
    error,
  };
}
// ------- Fetch Quotations
export function fetchQuotations() {
  return {
    type: types.FETCH_QUOTATIONS_REQUEST,
  };
}

export function fetchQuotationsSuccess({ data }) {
  return {
    type: types.FETCH_QUOTATIONS_SUCCESS,
    data,
  };
}

export function fetchQuotationsFail({ error }) {
  return {
    type: types.FETCH_QUOTATIONS_FAIL,
    error,
  };
}
// ------- Fetch Quotations as SalesRoute
export function fetchQuotationsSR() {
  return {
    type: types.FETCH_QUOTATIONS_SR_REQUEST,
  };
}

export function fetchQuotationsSRSuccess({ data }) {
  return {
    type: types.FETCH_QUOTATIONS_SR_SUCCESS,
    data,
  };
}

export function fetchQuotationsSRFail({ error }) {
  return {
    type: types.FETCH_QUOTATIONS_SR_FAIL,
    error,
  };
}
// ------- Put Quotation
export function putQuotation({ id, payload, next }) {
  return {
    type: types.PUT_QUOTATION_REQUEST,
    id,
    payload,
    next,
  };
}

export function putQuotationSuccess(data) {
  return {
    type: types.PUT_QUOTATION_SUCCESS,
    data,
  };
}

export function putQuotationFail(error) {
  return {
    type: types.PUT_QUOTATION_FAIL,
    error,
  };
}
// ------- Put Quotation as SalesRoute
export function putQuotationSR({ id, payload, next }) {
  return {
    type: types.PUT_QUOTATION_SR_REQUEST,
    id,
    payload,
    next,
  };
}

export function putQuotationSRSuccess(data) {
  return {
    type: types.PUT_QUOTATION_SR_SUCCESS,
    data,
  };
}

export function putQuotationSRFail(error) {
  return {
    type: types.PUT_QUOTATION_SR_FAIL,
    error,
  };
}
// ------- Calculate Quotation
export function fetchCalculateQuotation(data) {
  return {
    type: types.FETCH_CALCULATE_REQUEST,
    payload: data,
  };
}

export function fetchCalculateQuotationSuccess(data, id) {
  return {
    type: types.FETCH_CALCULATE_SUCCESS,
    data,
    id,
  };
}

export function fetchCalculateQuotationFail(error) {
  return {
    type: types.FETCH_CALCULATE_FAIL,
    error,
  };
}

// ------- Calculate Quotation as SalesRoute
export function fetchCalculateQuotationSR(data) {
  return {
    type: types.FETCH_CALCULATE_SR_REQUEST,
    payload: data,
  };
}

export function fetchCalculateOnlyQuotationSR(data, next) {
  return {
    type: types.FETCH_CALCULATE_ONLY_SR_REQUEST,
    payload: data,
    next,
  };
}

export function fetchCalculateQuotationSRSuccess(data, id) {
  return {
    type: types.FETCH_CALCULATE_SR_SUCCESS,
    data,
    id,
  };
}

export function fetchCalculateQuotationSRFail(error, id) {
  return {
    type: types.FETCH_CALCULATE_SR_FAIL,
    error,
    id,
  };
}

// ------- Submit Quotation
export function submitQuotation(data) {
  return {
    type: types.SUBMIT_QUOTATION_REQUEST,
    payload: data,
  };
}

export function submitQuotationSuccess(data, id) {
  return {
    type: types.SUBMIT_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function submitQuotationFail(error) {
  return {
    type: types.SUBMIT_QUOTATION_FAIL,
    error,
  };
}

// ------- print Quotation
export function printQuotation(data) {
  return {
    type: types.PRINT_QUOTATION_REQUEST,
    payload: data,
  };
}

export function printQuotationSuccess(data, id) {
  return {
    type: types.PRINT_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function printQuotationFail(error) {
  return {
    type: types.PRINT_QUOTATION_FAIL,
    error,
  };
}

// ------- print Quotation as SalesRoute
export function printQuotationSR(data) {
  return {
    type: types.PRINT_QUOTATION_SR_REQUEST,
    payload: data,
  };
}

export function printQuotationSRSuccess(data, id) {
  return {
    type: types.PRINT_QUOTATION_SR_SUCCESS,
    data,
    id,
  };
}

export function printQuotationSRFail(error) {
  return {
    type: types.PRINT_QUOTATION_SR_FAIL,
    error,
  };
}

// ------- cancel Quotation
export function cancelQuotation(payload) {
  return {
    type: types.CANCEL_QUOTATION_REQUEST,
    payload,
  };
}

export function cancelQuotationSuccess(data, id) {
  return {
    type: types.CANCEL_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function cancelQuotationFail(error) {
  return {
    type: types.CANCEL_QUOTATION_FAIL,
    error,
  };
}

// ------- cancel Quotation as SalesRoute
export function cancelQuotationSR(payload) {
  return {
    type: types.CANCEL_QUOTATION_SR_REQUEST,
    payload,
  };
}

export function cancelQuotationSRSuccess(data, id) {
  return {
    type: types.CANCEL_QUOTATION_SR_SUCCESS,
    data,
    id,
  };
}

export function cancelQuotationSRFail(error) {
  return {
    type: types.CANCEL_QUOTATION_SR_FAIL,
    error,
  };
}

// ------- put on hold Quotation
export function putOnHoldQuotation(data) {
  return {
    type: types.PUTONHOLD_QUOTATION_REQUEST,
    payload: data,
  };
}

export function putOnHoldQuotationSuccess(data, id) {
  return {
    type: types.PUTONHOLD_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function putOnHoldQuotationFail(error) {
  return {
    type: types.PUTONHOLD_QUOTATION_FAIL,
    error,
  };
}

// ------- Duplicate Quotation SR
export function duplicateQuotationSR({ data, id }) {
  return {
    type: types.DUPLICATE_QUOTATION_SR_REQUEST,
    payload: data,
    id,
  };
}

export function duplicateQuotationSRSuccess(data) {
  return {
    type: types.DUPLICATE_QUOTATION_SR_SUCCESS,
    data,
  };
}

export function duplicateQuotationSRFail(error) {
  return {
    type: types.DUPLICATE_QUOTATION_SR_FAIL,
    error,
  };
}

// ------- Fetch Product
export function fetchProduct({ id }) {
  return {
    type: types.FETCH_PRODUCT_REQUEST,
    id,
  };
}

export function fetchProductSuccess(data, id) {
  return {
    type: types.FETCH_PRODUCT_SUCCESS,
    data,
    id,
  };
}

export function fetchProductFail(error) {
  return {
    type: types.FETCH_PRODUCT_FAIL,
    error,
  };
}

// redirect
export function setRedirectStatus(isRedirect) {
  return {
    type: types.SET_REDIRECT,
    isRedirect,
  };
}
// ------- Fetch Lenders
export function fetchLenders() {
  return {
    type: types.FETCH_LENDERS_REQUEST,
  };
}

export function fetchLendersSuccess(data) {
  return {
    type: types.FETCH_LENDERS_SUCCESS,
    data,
  };
}

export function fetchLendersFail(error) {
  return {
    type: types.FETCH_LENDERS_FAIL,
    error,
  };
}

// ------- Fetch Lender Addresses
export function fetchLenderAddresses(id) {
  return {
    type: types.FETCH_LENDER_ADDRESSES_REQUEST,
    id,
  };
}

export function fetchLenderAddressesSuccess(data, id) {
  return {
    type: types.FETCH_LENDER_ADDRESSES_SUCCESS,
    data,
    id,
  };
}

export function fetchLenderAddressesFail(error, id) {
  return {
    type: types.FETCH_LENDER_ADDRESSES_FAIL,
    error,
    id,
  };
}

// ------- Fetch Kinds
export function fetchKinds() {
  return {
    type: types.FETCH_KINDS_REQUEST,
  };
}

export function fetchKindsSuccess(data) {
  return {
    type: types.FETCH_KINDS_SUCCESS,
    data,
  };
}

export function fetchKindsFail(error) {
  return {
    type: types.FETCH_KINDS_FAIL,
    error,
  };
}
// ------- Fetch Deferrals
export function fetchDeferrals() {
  return {
    type: types.FETCH_DEFERRALS_REQUEST,
  };
}

export function fetchDeferralsSuccess(data) {
  return {
    type: types.FETCH_DEFERRALS_SUCCESS,
    data,
  };
}

export function fetchDeferralsFail(error) {
  return {
    type: types.FETCH_DEFERRALS_FAIL,
    error,
  };
}
// ------- Fetch Banks
export function fetchBanks(inputValue) {
  return {
    type: types.FETCH_BANKS_REQUEST,
    inputValue,
  };
}

export function fetchBanksSuccess(data) {
  return {
    type: types.FETCH_BANKS_SUCCESS,
    data,
  };
}

export function fetchBanksFail(error) {
  return {
    type: types.FETCH_BANKS_FAIL,
    error,
  };
}
// ------- validate iban request
export function validateIban(iban) {
  return {
    type: types.VALIDATE_IBAN_REQUEST,
    iban,
  };
}

export function validateIbanSuccess({ data, iban }) {
  return {
    type: types.VALIDATE_IBAN_SUCCESS,
    data,
    iban,
  };
}

export function validateIbanFail({ error, iban }) {
  return {
    type: types.VALIDATE_IBAN_FAIL,
    error,
    iban,
  };
}

// ------- Submit Quotations / Multi contracts
export function submitQuotations(data) {
  return {
    type: types.SUBMIT_QUOTATIONS_REQUEST,
    payload: data,
  };
}

export function submitQuotationsSuccess(data, id) {
  return {
    type: types.SUBMIT_QUOTATIONS_SUCCESS,
    data,
    id,
  };
}

export function submitQuotationsFail(error) {
  return {
    type: types.SUBMIT_QUOTATIONS_FAIL,
    error,
  };
}

// ------- Submit Quotations / Multi contracts as SalesRoute
export function submitQuotationsSR(data) {
  return {
    type: types.SUBMIT_QUOTATIONS_SR_REQUEST,
    payload: data,
  };
}

export function submitOnlyQuotationsSR(data, next, calc) {
  return {
    type: types.SUBMIT_ONLY_QUOTATIONS_SR_REQUEST,
    payload: data,
    next,
    calc,
  };
}

export function submitQuotationsSRSuccess(data, id) {
  return {
    type: types.SUBMIT_QUOTATIONS_SR_SUCCESS,
    data,
    id,
  };
}

export function submitQuotationsSRFail(error) {
  return {
    type: types.SUBMIT_QUOTATIONS_SR_FAIL,
    error,
  };
}

// ------------ validate Quotation -------------
export function validateQuotation({ quotation, id }) {
  return {
    type: types.VALIDATE_QUOTATION_REQUEST,
    quotation,
    id,
  };
}

export function validateQuotationSuccess(data, id) {
  return {
    type: types.VALIDATE_QUOTATION_SUCCESS,
    data,
    id,
  };
}

export function validateQuotationFail(error) {
  return {
    type: types.VALIDATE_QUOTATION_FAIL,
    error,
  };
}

// ------------ validate Quotation as SalesRoute -------------
export function validateQuotationSR({ quotation, id }) {
  return {
    type: types.VALIDATE_QUOTATION_SR_REQUEST,
    quotation,
    id,
  };
}

export function validateQuotationSRSuccess(data, id) {
  return {
    type: types.VALIDATE_QUOTATION_SR_SUCCESS,
    data,
    id,
  };
}

export function validateQuotationSRFail(error) {
  return {
    type: types.VALIDATE_QUOTATION_SR_FAIL,
    error,
  };
}

// ------------ need Recalculate -------------
export function needRecalculate(error) {
  return {
    type: types.NEED_RECALCULATE,
    error,
  };
}

// ------------ reset Offer -------------
export function resetOffer(id) {
  return {
    type: types.RESET_OFFER,
    id,
  };
}
